import { Button } from '@one-thd/sui-atomic-components';
import React from 'react';
import { FeatureSwitches } from '../../../constants/feature-switches';
import { useCommonContext } from '../../../hooks/useContexts';
import { IPHDeliveryTrackerActions } from '../../../models/delivery-tracker';
import { IFulfillmentGroup } from '../../../models/order-details';
import { isPrintReturnLabelEnabled } from '../../../utils/order-details/OrderDetailsUtils';
import { pushDeliveryTrackerButtonClickedEvent } from '../../../utils/purchase-history/analytics';
import { isLegacyUPSReturn } from '../../../utils/returns/helpers-with-fs';
import { getFulfillmentStatus } from '../../order-details/util/FulfillmentStatus';
import SorisQRButton from '../../shared/QR/SorisQRButton';
import ViewUPSBarcodeButton from '../../shared/ups-barcode/ViewUpsBarcodeButton';

export const PHOrderActions = ({
  deliveryTrackerData,
  emailId,
  fulfillmentGroup,
  fulfillmentType,
  isInitiatedReturn,
  isSoris,
  net,
  orderNumber,
  trackingNumbers,
  variant,
  isPTCOrder,
}: IPHDeliveryTrackerActions) => {
  const { isMobile } = useCommonContext();

  const isViewSorisQRCodeBtnEnabled =
    Boolean(FeatureSwitches.allowViewSorisQrCode) &&
    isSoris &&
    isInitiatedReturn;

  const isLegacyReturn = isLegacyUPSReturn(
    fulfillmentGroup?.lineItems?.[0]?.statusUpdatedDate,
  );

  const fulfillmentStatus = getFulfillmentStatus(
    fulfillmentGroup?.fulfillmentType ?? '',
  );

  const printReturnLabelEnabled = isPrintReturnLabelEnabled(
    fulfillmentGroup ?? ({} as IFulfillmentGroup),
    fulfillmentStatus,
    isInitiatedReturn,
    trackingNumbers,
    isSoris,
  );

  const isViewUpsBarcodeButton = !isLegacyReturn && printReturnLabelEnabled;

  if (!deliveryTrackerData) return null;

  return (
    <>
      {!['InStorePurchase', 'BuyOnlinePickupInStore'].includes(
        fulfillmentType ?? '',
      ) && (
        <div
          className={`ButtonGroup  ${isMobile ? 'sui-mt-[16px]' : ''} ${
            isMobile ? '' : 'sui-ml-[32px]'
          } sui-w-full
       ${
         variant === 'card'
           ? 'sm:sui-max-w-[311px] md:sui-max-w-[360px]'
           : 'md:sui-max-w-[200px]'
       } ${isMobile ? 'sui-ml-[0px]' : ''}`}
        >
          {deliveryTrackerData !== null &&
            ['STH', 'DFS', 'BODFS', 'MA', 'BOSS'].includes(
              deliveryTrackerData?.deliveryType ?? '',
            ) &&
            fulfillmentGroup?.lineItems?.[0]?.statusDescription !==
              'Canceled' &&
            fulfillmentGroup?.lineItems?.[0]?.statusDescription !==
              'Returned' &&
            fulfillmentGroup?.lineItems?.[0]?.statusDescription !==
              'Return Initiated' &&
            (deliveryTrackerData?.links?.internalTrackingUrl ||
              deliveryTrackerData?.links?.deliveryTrackerUrl) && (
              <Button
                href={
                  (deliveryTrackerData?.links?.internalTrackingUrl ||
                    deliveryTrackerData?.links?.deliveryTrackerUrl) ??
                  ''
                }
                variant="secondary"
                onClick={pushDeliveryTrackerButtonClickedEvent}
              >
                Track Delivery
              </Button>
            )}
          <div className="sui-flex sui-flex-col sui-gap-y-[16px]">
            {isViewSorisQRCodeBtnEnabled && (
              <SorisQRButton
                fulfillmentGroup={fulfillmentGroup ?? ({} as IFulfillmentGroup)}
                orderId={orderNumber ?? ''}
                emailId={emailId}
                net={net ?? ''}
                variant="secondary"
              />
            )}
            {isViewUpsBarcodeButton && (
              <ViewUPSBarcodeButton
                items={fulfillmentGroup?.lineItems || []}
                variant="secondary"
                isPTCOrder={isPTCOrder}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};
